import { render, staticRenderFns } from "./BaseTitle.vue?vue&type=template&id=1af870cf&scoped=true"
import script from "./BaseTitle.vue?vue&type=script&lang=js"
export * from "./BaseTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af870cf",
  null
  
)

export default component.exports